export const LISTING_STATUS = {
  NONE: '',
  RESERVED: 'reserved',
  SOLD: 'sold',
};

export const LISTING_STATUS_OPTIONS = [
  { value: LISTING_STATUS.NONE, labelKey: 'admin.form.listingStatusNone' },
  { value: LISTING_STATUS.RESERVED, labelKey: 'propertyDetails.reserved' },
  { value: LISTING_STATUS.SOLD, labelKey: 'propertyDetails.sold' },
];

export const resolveListingStatus = (property) => {
  if (!property) return LISTING_STATUS.NONE;
  if (property.listingStatus) return property.listingStatus;
  if (property.featured === true) return LISTING_STATUS.RESERVED;
  return LISTING_STATUS.NONE;
};

export const getListingStatusLabel = (status, t) => {
  if (status === LISTING_STATUS.RESERVED) {
    return t('propertyDetails.reserved') || 'Rezervuar';
  }
  if (status === LISTING_STATUS.SOLD) {
    return t('propertyDetails.sold') || 'Shitur';
  }
  return '';
};
